import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  Input,
  OnDestroy,
} from '@angular/core';
import { OrganizationService } from '../../../organizations/organization.service';
import { Observable, Subject } from 'rxjs';
import { map, filter, takeUntil } from 'rxjs/operators';
import { locales } from '../../services/language.service';
import { Organization } from '../../sdk';

@Component({
  selector: 'app-input-flags',
  templateUrl: './input-flags.component.html',
  styleUrls: ['./input-flags.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFlagsComponent implements OnInit, OnDestroy {
  @Input() activeLocale: string;
  @Input() activeOrg: Organization;
  @Input() alignRight = false;
  @Input() hiddenFlags: string[];
  @Input() hidable = true;
  @Output() selected = new EventEmitter<string>();
  locales: Observable<any>;
  private onDestroy = new Subject<void>();

  constructor(private orgService: OrganizationService) {}

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngOnInit(): void {
    this.locales = this.orgService.active.pipe(
      filter((org) => !!org),
      map((org) => {
        const localeShort = org.locale.split('-')[0];
        let l = [...locales];
        const curIdx = l.findIndex((e) => e.symbol === localeShort);

        if (curIdx !== -1) {
          const c = l[curIdx];
          l = [c, ...l.slice(0, curIdx), ...l.slice(curIdx + 1)];
        } else {
          // add unknown locale as default
          l = [
            { symbol: localeShort, name: 'default', flag: localeShort },
            ...l,
          ]
        }

        return l;
      }),
      takeUntil(this.onDestroy),
    );

    this.orgService.active
      .pipe(
        filter((org) => !!org),
        takeUntil(this.onDestroy)
      )
      .subscribe((org) => this.setActive(org.locale.split('-')[0] || 'en'));
  }

  onSelect(locale: any): void {
    if (this.activeLocale === locale.symbol) {
      return;
    }

    this.setActive(locale.symbol);
    this.selected.emit(locale);
  }

  visible(locale: string): boolean {
    return !this.hiddenFlags || this.hiddenFlags.indexOf(locale) === -1;
  }

  private setActive(locale: string): void {
    this.activeLocale = locale;
  }
}
